export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - Regardez des matchs NBA en direct | NBA.com',
	seo_meta_desc_leaguepass: 'Regardez des matchs NBA en direct et à la demande avec le League Pass. Accédez à votre compte ici.',
	seo_meta_keywords_leaguepass: 'vidéos NBA, temps forts NBA, vidéos basket-ball, principaux matches, dunks, dossiers',
	seo_meta_title_featured: 'Regardez des matchs et des highlights de la NBA | NBA.com',
	seo_meta_desc_featured: 'Regardez gratuitement des vidéos, actualités et analyses sur la NBA. Découvrez également les divers abonnements NBA TV et League Pass pour suivre les matchs en direct sur vos appareils préférés.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - Regardez des matchs en direct et profitez d\'une couverture 24 h/24 | NBA.com',
	seo_meta_desc_nbatv: 'Regardez des matchs en direct ou les plus grands classiques sur NBA TV. En prime, accédez à des émissions et à des analyses sur toutes les équipes de la ligue.',
	seo_meta_keywords_nbatv: 'chaîne NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, émissions studio, the jump',
	seo_meta_title_classicgames: 'Regardez des matchs légendaires avec NBA TV et d\'autres offres | NBA.com',
	seo_meta_desc_classicgames: 'Accédez à des rencontres légendaires avec NBA TV. Regardez aussi des matchs en direct sur NBA TV et accédez à des émissions et des analyses sur les équipes de toute la ligue.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'Regardez du contenu ici | NBA.com',
	seo_meta_title_videolist: 'Regardez {0} ici | NBA.com',
	seo_meta_desc_videolist: 'Regardez {0} des vidéos ici. Découvrez également les abonnements NBA TV et League Pass pour regarder des matchs en direct sur vos appareils préférés.',
	seo_meta_title_videolist_show: 'Regardez {0} avec NBA TV | NBA.com',
	seo_meta_desc_videolist_show: 'Regardez {0} ici. En prime, regardez des matchs en direct sur NBA TV et accédez à des matchs de légende et des analyses.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'Regardez {0} ici | NBA.com',
	seo_meta_desc_videolist_feed: 'Regardez {0} des vidéos ici. Découvrez également les abonnements NBA TV et League Pass pour regarder des matchs en direct sur vos appareils préférés.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Regardez des émissions en studio avec NBA TV et d\'autres offres | NBA.com',
	seo_meta_desc_shows: 'Découvrez et regardez à la demande les derniers épisodes et reportages de NBA TV. En prime, regardez des matchs en direct sur NBA TV et accédez à des matchs de légende et des analyses.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Accueil | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Chaînes | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Chaîne | NBA.com',
	seo_meta_pre_title_categories: 'Catégories | NBA.com',
	seo_meta_title_categories: 'Catégories | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Catégorie | NBA.com',
	seo_meta_title_category: 'Catégorie | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Regardez des vidéos ici | NBA.com',
	seo_meta_pre_title_event: 'Regardez des événements ici | NBA.com',
	seo_meta_title_events: 'Événements | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'Regardez{0} ici | NBA.com',
	seo_meta_desc_event: 'Regardez {0} ici. Découvrez également les abonnements NBA TV et League Pass pour regarder des matchs en direct sur vos appareils préférés.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Recherche | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Page non trouvée | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Regardez un match ici | NBA.com',
	seo_meta_title_game: 'Regardez {0} ici | NBA.com',
	seo_meta_desc_game: 'Regardez {0} ici. Découvrez également les abonnements NBA TV et League Pass pour regarder des matchs en direct sur vos appareils préférés.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'Regardez {0} ici | NBA.com',
	seo_meta_desc_video: 'Regardez {0} ici. Découvrez également les abonnements NBA TV et League Pass pour regarder des matchs en direct sur vos appareils préférés.',
	seo_meta_keywords_video: 'vidéos NBA, temps forts NBA, vidéos basket-ball, principaux matches, dunks, dossiers',
	seo_meta_title_episode: 'Regardez {0} avec NBA TV | NBA.com',
	seo_meta_desc_episode: 'Regardez {0} ici. En prime, regardez des matchs en direct sur NBA TV et accédez à des matchs de légende et des analyses.',
	seo_meta_keywords_episode: 'vidéos NBA, temps forts NBA, vidéos basket-ball, principaux matches, dunks, dossiers',
	seo_meta_title_channel: 'NBA TV en direct | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live est votre service live streaming 24h/24 de la chaîne NBA TV avec des matches NBA en direct et d\'archives toutes leurs semaines, programmation studio et couverture par des analystes',
	seo_meta_keywords_channel: 'chaîne NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, émissions studio, the jump',
	seo_meta_title_tvguide: 'Programme de diffusion en direct sur NBA TV | NBA.com',
	seo_meta_desc_tvguide: 'Avec NBA TV sur votre appareil préféré, vous savez toujours quand vous pouvez regarder des matchs et des émissions en direct. En prime, vous accédez à des émissions et analyses à la demande.',
	seo_meta_keywords_tvguide: 'chaîne NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, émissions studio, the jump',

	// Common
	timezone: 'ET',
	default_feed_error_message: 'Une erreur s\'est produite, le contenu n\'est pas disponible pour le moment. Merci de réessayer.',
	watch_in_app: 'REGARDER SUR L\'APPLICATION NBA',
	ad_blocked_message: 'Bloqueur de publicités détecté : le contenu de NBA.com est financé grâce à la publicité. Pour continuer à profiter de notre contenu, veuillez désactiver votre bloqueur de publicités.',

	// Item
	no_content: 'Pas de contenu',
	see_more: 'Voir plus',
	now_playing: 'LECTURE EN COURS',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Vous avez atteint le nombre maximal de vidéos préférées. Supprimez-en certaines avant d\'en ajouter d\'autres.',
	item_live: 'En direct :',
	add_favourite_title: 'AJOUTER AUX FAVORIS',
	remove_favourite_title: 'SUPPRIMER DES FAVORIS',
	// Channel: Schedule
	p_channel_live: 'En direct :',
	p_channel_schedule_title: 'Calendrier NBA TV',
	p_channel_schedule_watch: 'Regarder',
	p_channel_live24x7_title: 'NBA TV 24 h/24, 7 j/7',
	p_channel_live24x7_see_full_schedule: 'Voir le programme complet',
	p_channel_live24x7_up_next: 'Prochaine diffusion',
	p_channel_live24x7_on_demand: 'NBA TV : à la demande',
	p_channel_live24x7_collection: 'Collection',
	p_channel_live24x7_demand_1_logo_text: 'émissions originales',
	p_channel_live24x7_demand_1_show_name: 'Émissions NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Émissions NBA TV originales, avec notamment Shaqtin\' a Fool, Beyond the Paint, Game Time et Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Classic Games',
	p_channel_live24x7_demand_2_show_name: 'NBA | Matchs classiques',
	p_channel_live24x7_demand_2_show_desc: 'Regardez des matchs classiques en entier, avec notamment tous les matchs des Finales depuis 2000, des moments qui ont marqué l\'histoire de la ligue et des joueurs légendaires',

	// Channel: Clips
	p_channel_error_msg: 'Pas encore disponible',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Calendrier',

	// NBA TV Shows:
	p_nba_tv_shows: 'Émissions NBA TV',
	p_nba_tv_no_access_title: 'NBA 24 h/24, 7 j/7 : restez informé grâce aux analyses de match, aux analyses studio, aux programmes originaux et plus encore !',
	p_nba_tv_no_access_desc: 'Regardez des matchs en direct, ainsi que des émissions et des matchs classiques à la demande.',
	p_nba_tv_no_access_note: 'Des restrictions de diffusion peuvent s\'appliquer',

	// tv show item
	tv_show_item_latest_episode: 'dernier épisode',
	tv_show_item_no_latest_episode: 'pas de dernier épisode',
	see_all: 'Voir tout',
	// header
	header_menu_watch: 'Regarder',
	header_menu_featured: 'À LA UNE',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: 'Joueurs',
	videos: 'Vidéos',
	teams: 'Équipes',
	most_searched: 'LES PLUS RECHERCHÉS',
	no_result: 'Pas de données',
	search_filter_type_most_relevant: 'Le plus pertinent',
	search_filter_type_most_viewed: 'Le plus regardé',
	search_filter_type_most_recent: 'Le plus récent',
	search_filter_type_last_30_days: 'Les 30 derniers jours',
	search_filter_type_last_6_months: 'Les 6 derniers mois',
	search_result_label: 'Résultats de recherche pour \'{keyword}\'',
	search_result_info: 'Afficher tous les résultats pour {keyword}',
	search_placeholder: 'Rechercher dans la vidéothèque',
	load_more: 'Charger plus...',

	// button
	button_subscribe: 'S\'abonner',
	button_sign_in: 'Connexion',
	button_tv_provider: 'Sélectionnez un fournisseur TV',

	// league page
	p_league_pass_no_access_title: 'Regardez les matchs en direct ou en replay sur n\'importe quel appareil, y compris votre ordinateur, votre smartphone ou votre téléviseur !',
	p_league_pass_no_access_desc: 'Toute l\'action à portée de main : regardez toutes les équipes de la ligue ou votre équipe préférée, choisissez un match à l\'unité, ou découvrez les autres options disponibles.',
	p_league_pass_no_access_note: 'Les conditions générales s\'appliquent',

	// Video
	category_title: 'Vidéo',
	p_video_playlist_title: 'Liste de lecture :',
	p_video_episode_text: 'Épisode',
	p_no_access_league_pass_title: 'Débloquez le NBA League Pass pour regarder :',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'Toute l\'action à portée de main : regardez toutes les équipes de la ligue ou votre équipe préférée, choisissez un match unique, ou découvrez les autres options disponibles.',
	p_no_access_league_pass_terms: 'Les conditions générales s\'appliquent',
	p_no_access_league_pass_geo_desc: 'D\'après votre position actuelle, vous n\'êtes pas en mesure de regarder ce match via le NBA League Pass et NBA TV. Pour les abonnés au NBA League Pass, une archive du match sera disponible 3 jours après sa diffusion. Veuillez consulter les horaires des diffuseurs TV et radio locaux, pour profiter des retransmissions locales dans votre région.',
	p_no_access_league_pass_not_found_desc: 'Désolé. La vidéo demandée est introuvable.',
	p_no_access_event_geo_desc: 'Cette retransmission n\'est pas disponible pour les fans aux États-Unis ou au Canada. Pour regarder le match, veuillez vous brancher sur ESPN aux États-Unis, et sur TSN ou Sportsnet au Canada.',
	p_no_access_event_not_found_desc: 'Désolé. L\'événement demandé est introuvable.',
	p_no_access_nba_tv_title: 'Débloquez NBA TV pour regarder :',
	p_no_access_nba_tv_desc: 'Regardez des matchs en direct, des émissions et des matchs classiques à la demande.',
	p_no_access_nba_tv_terms: 'Les conditions générales s\'appliquent',
	p_no_access_nba_tv_geo_desc: 'D\'après votre position actuelle, vous n\'êtes pas en mesure de regarder ce match via le NBA League Pass et NBA TV. Pour les abonnés au NBA League Pass, une archive du match sera disponible 3 jours après sa diffusion. Veuillez consulter les horaires des diffuseurs TV et radio locaux, pour profiter des retransmissions locales dans votre région.',
	p_no_access_nba_tv_not_found_desc: 'Désolé. La chaîne demandée est introuvable.',
	p_no_access_up_next: 'Prochaine diffusion :',
	p_video_completed_title: 'Playlist terminée',
	p_video_completed_desc: 'Revenez au navigateur ou consultez la prochaine playlist concoctée pour vous',
	p_video_share_to: 'Partager à :',
	p_video_more_to_watch: 'Plus encore :',

	// Event
	p_event_section_title: 'ÉVÉNEMENT',
	p_event_playlist_title: 'Liste de lecture :',
	p_event_button_watch: 'Regarder',
	p_event_button_listen: 'Écouter',
	p_event_button_ticket: 'Billet',

	// notfound page
	notfound: 'Désolé. La page demandée est introuvable.',
	notfound_desc: 'Vérifiez l\'URL.<br/> Vous pouvez également utiliser  l\'outil de navigation ou de recherche du site pour trouver le contenu souhaité.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Votre compte NBA League Pass a atteint le niveau maximal de diffusion. Cliquez sur « Continuer » pour reprendre le visionnement sur cet appareil.',
	modal_pcm_custom: 'Continuer',
	modal_pcm_close: 'Annuler',
	modal_pcm_ok: 'OK',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Cette vidéo ne peut être visionnée sur votre appareil. Cliquez sur <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>ICI</a> pour obtenir de l\'assistance.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',
	modal_video_unsupported_ok: 'OK',

	// FreeSample
	freesample_notice_time: 'Temps restant',
	freesample_notice_title: 'Profitez de vos {0} minutes d’accès',
	freesample_notice_desc: 'Abonnez-vous à une offre complète du League Pass pour continuer à profiter des contenus NBA à la fin de vos {0} minutes.',
	freesample_notice_subscribe_button: 'S\'abonner',
	freesample_notice_cancel_button: 'SANS ENGAGEMENT',
	freesample_popup_title: 'VOTRE TEMPS D\'ACCÈS EST ÉPUISÉ',
	freesample_popup_subtitle: 'Abonnez-vous au League Pass pour accéder à bien plus de contenus fascinants de la NBA.',
	freesample_popup_link: 'En savoir plus',
	freesample_popup_get_minutes_button: 'OBTENIR {0}  MINUTES',

	// Video list
	reg_required_desc: 'Vous devez vous connecter pour voir ce contenu',
	favorite_teams_title: 'Équipes préf.',
	bookmarked_title: 'Enregistré',
	watch_history_title: 'Continuer à regarder',
	game_schedule_title: 'Calendrier des matchs',
	recommended_title: 'Conseillé',
	season_text: 'Saison',

	// profile page
	section_information_title: 'Mes informations',
	section_information_desc: 'Actualiser vos informations personnelles',
	section_information_email: 'E-mail',
	section_information_email_update: 'Actualiser l\'adresse e-mail',
	section_information_password: 'Mot de passe',
	section_information_password_update: 'Modifier le mot de passe',
	section_information_social: 'Connexion via les réseaux sociaux',
	section_information_nosocial_message: 'Vous n\'avez pas de comptes associés.',
	section_information_firstname: 'Prénom',
	section_information_lastname: 'Nom',
	section_information_birth: 'Date de naissance',
	section_information_country: 'Pays / Région',
	section_information_postalcode: 'Code postal',
	section_information_edit: 'Modifier',
	section_tv_provider_title: 'Mon fournisseur TV',
	section_tv_provider_desc: 'Accédez aux matchs et aux flux en direct de votre fournisseur TV.',
	section_tv_provider_faq: 'FAQ du fournisseur TV',
	section_tv_provider_sign_out: 'Se déconnecter',
	section_tv_provider_sign_in: 'Se connecter au fournisseur TV',
	section_fantasy_title: 'Informations insolites',
	section_fantasy_desc: 'Afficher les informations de votre compte Fantasy',
	section_fantasy_displayname: 'Afficher un nom',
	section_marketing_title: 'Préférences d\'e-mail',
	section_marketing_desc: 'Afficher vos préférences de communication marketing et de confidentialité',
	section_marketing_newsletters: 'Lettres d\'information',
	section_marketing_message: 'Messages et publicités NBA',
	section_marketing_newsletters_desc_1: 'L\'actualité de la NBA livrée quotidiennement dans votre boîte mail',
	section_marketing_newsletters_desc_2: 'Actualités et fonctionnalités relatives à la NBA G League, la ligue mineure officielle de la NBA',
	section_marketing_newsletters_desc_3: 'Actualités et contenu relatifs à la Jr. NBA, l\'initiative de la NBA en faveur des jeunes et du basket-ball',
	section_marketing_newsletters_desc_4: 'Dernières fonctionnalités de l\'application NBA, ainsi que les mises à jour et les offres du League Pass',
	section_marketing_newsletters_desc_5: 'Tarifs spéciaux sur les billets, offres partenaires, remises sur les événements et les produits de la NBA',
	section_marketing_newsletters_desc_6: 'Actualités et contenus NBA triés sur le volet, livrés chaque semaine dans votre boîte mail',
	section_marketing_newsletters_desc_7: 'Actualités WNBA et offres de la WNBA et de ses partenaires.',
	section_marketing_personal_title: 'Mes informations personnelles',
	section_marketing_personal_desc: 'Veuillez utiliser mes informations personnelles pour que la NBA m\'envoie des messages et des publicités sur les produits et les initiatives de la NBA et des partenaires de la NBA.',
	section_marketing_update_button: 'Mettre à jour les préférences marketing',
	section_marketing_update_success: 'Vos préférences ont bien été mises à jour.',
	section_ccpa_title: 'Ne pas divulguer mes informations personnelles',

	// profile edit modal
	email_modal_title: 'mettre a jour l\'adresse e-mail',
	email_modal_new_email_label: 'nouvelle adresse e-mail',
	email_modal_update: 'Mettre à jour',
	email_modal_cancel: 'Annuler',
	password_modal_title: 'Modifier le mot de passe',
	password_modal_current_label: 'Mot de passe actuel :',
	password_modal_new_label: 'Nouveau mot de passe :',
	password_modal_confirm_label: 'Confirmez le mot de passe',
	password_modal_update: 'Mettre à jour',
	password_modal_cancel: 'Annuler',
	personal_modal_title: 'mettre à jour les informations personnelles',
	personal_modal_email: 'E-mail',
	personal_modal_password: 'Mot de passe',
	personal_modal_birth: 'Date de naissance',
	personal_modal_social: 'Connexion via les réseaux sociaux',
	personal_modal_firstname: 'Prénom',
	personal_modal_lastname: 'Nom',
	personal_modal_country: 'Pays / Région',
	personal_modal_postalcode: 'Code postal',
	personal_modal_zipcode: 'Code postal',
	personal_modal_postalcode_invalid_message: 'Code postal valide requis',
	personal_modal_zipcode_invalid_message: 'Code postal valide requis',
	personal_modal_update: 'Mettre à jour',
	personal_modal_cancel: 'Annuler',

	// payflow
	payflow_profile_name: 'Nom',
	payflow_profile_email: 'E-mail',

	// account page
	header_menu_account_my_account: 'Mon compte',
	header_menu_account_manage_account: 'Gérer mon compte',
	header_menu_account_favorite_teams: 'Équipes préférées',
	header_menu_account_favorite_players: 'Joueurs préférés',
	header_menu_account_viewing_history: 'Historique de visionnage',
};
